import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { BehaviorSubject, Subscription } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  tap,
  switchMap,
  map,
  finalize,
} from "rxjs/operators";
import { EventService } from "src/app/core/services/event.service";
import { ContactsService } from "src/app/pages/contacts/services/contacts.service";
import Swal from "sweetalert2";
import { ContactModel } from "../../../../models/contacts.model";
import { environment } from "src/environments/environment";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-contacts-create-edit-developments",
  templateUrl: "./contacts-create-edit.component.html",
  styleUrls: ["./contacts-create-edit.component.scss"],
})
export class ContactsCreateEditDevelopmentsComponent
  implements OnInit, OnDestroy
{
  private currentNavTabSubject!: BehaviorSubject<number>;
  nabTabActive = 1;
  textTitleModal: string = "t-add-costumer";
  textTitleTabList: string = "t-costumers";
  textTitleNewContact: string = "t-new-costumer";
  textAddOrUpdateModal: string = "t-save";
  @ViewChild("content1", { static: true }) content1!: ElementRef;
  costumersDetailsForm!: FormGroup;
  ownersDetailsForm!: FormGroup;
  submittedCostumersForm: boolean = false;
  submittedOwnersForm: boolean = false;
  isShowCostumersForm = false;
  isShowOwnersForm = false;
  contactTypes!: {
    id: number;
    name?: string;
    description?: string;
    translateKey?: string;
    isDefault?: boolean;
    status?: boolean;
    isActive?: boolean;
  }[];
  statusOwners = false;
  isUpdateContact = false;
  contactUpdate: any;
  modalContact!: NgbModalRef;
  subscription: Subscription = new Subscription();
  contacts!: ContactModel[];
  allContacts!: ContactModel[];
  total = 0;
  checkedList!: ContactModel[];
  page: number = 1;
  pageSize: number = 5;
  startIndex: number = 1;
  endIndex: number = 5;
  filter: string = "";
  masterSelected!: boolean;
  countCheckSelected = 0;
  noresult: boolean = false;
  hideElement: boolean = true;
  queryField = new FormControl();
  propertyId: any;
  contactsDelete!: ContactModel[];
  dirContactsfiles = `${environment.apiUrl}${environment.dirContactsfiles}/`;
  init: boolean = true;

  phoneInvalid: boolean = false;
  emailInvalid: boolean = false;
  phoneExists: boolean = false;
  emailExists: boolean = false;

  documentTypes: { text: string; value: string }[] = [
    { text: "t-document-types.t-citizen-card", value: "CITIZEN_CARD" },
    { text: "t-document-types.t-id-card", value: "ID_CARD" },
    { text: "t-document-types.t-passport", value: "PASSPORT" },
    { text: "t-document-types.t-residence", value: "RESIDENCE" },
  ];
  proposerActionTypes: { text: string; value: string }[] = [
    { text: "t-proposer-action-types.t-other", value: "OTHER" },
    { text: "t-proposer-action-types.t-self", value: "SELF" },
  ];
  maritalStatus: { text: string; value: string }[] = [
    { text: "t-marital-status.t-single", value: "SINGLE" },
    { text: "t-marital-status.t-married", value: "MARRIED" },
    { text: "t-marital-status.t-divorced", value: "DIVORCED" },
    { text: "t-marital-status.t-widowed", value: "WIDOWED" },
    { text: "t-marital-status.t-separated", value: "SEPARATED" },
  ];
  maritalPropertyRegime: { text: string; value: string }[] = [
    {
      text: "t-marital-regime.t-communion-acquired",
      value: "COMMUNION_ACQUIRED",
    },
    {
      text: "t-marital-regime.t-communion-general",
      value: "COMMUNION_GENERAL",
    },
    { text: "t-marital-regime.t-separation", value: "SEPARATION" },
    { text: "t-marital-regime.t-other", value: "OTHER" },
  ];

  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private eventService: EventService,
    private contactsService: ContactsService,
    private translate: TranslateService
  ) {
    this.currentNavTabSubject = new BehaviorSubject<number>(this.nabTabActive);
  }

  private ensureLegacyContactTypeOption(
    sources: any[] = [],
    contact?: any,
  ): any[] {
    const normalizedSources = Array.isArray(sources) ? [...sources] : [];
    const selectedSourceId = Number(
      contact?.contactType?.id ?? contact?.contactType,
    );

    if (!Number.isFinite(selectedSourceId) || selectedSourceId <= 0) {
      return normalizedSources;
    }

    const alreadyExists = normalizedSources.some(
      (source) => Number(source?.id) === selectedSourceId,
    );
    if (alreadyExists) {
      return normalizedSources;
    }

    const sourceDetails = contact?.contactSourceDetails || contact?.contactSource || {};
    const fallbackName =
      sourceDetails?.name ||
      sourceDetails?.description ||
      `#${selectedSourceId}`;
    return [
      {
        id: selectedSourceId,
        name: fallbackName,
        description: fallbackName,
        translateKey: sourceDetails?.translateKey,
        isDefault: sourceDetails?.isDefault,
        status: sourceDetails?.status !== false,
        isActive: sourceDetails?.status !== false,
      },
      ...normalizedSources,
    ];
  }

  ngOnInit(): void {
    const subscriptionModalContact = this.eventService.subscribe(
      "open-modal-contacts-dev",
      (data: any) => {
        this.masterSelected = false;
        this.checkedList = [];
        this.contacts = [];
        this.contactsDelete = [];
        this.total = 0;
        this.isShowCostumersForm = false;
        this.isShowOwnersForm = false;
        this.isUpdateContact = false;
        this.submittedCostumersForm = false;
        this.submittedCostumersForm = false;
        this.contactUpdate = data.contact;
        this.propertyId = data.propertyId;

        if (data.modal === "costumers") {
          this.isShowCostumersForm = true;
          this.initCostumersFormValidation(data);
          this.contactTypes = this.ensureLegacyContactTypeOption(
            data.contactsTypes,
            data.contact,
          );
          this.hideElement = false;

          data.contactsAux.forEach((c: any) => {
            const cont = c;
            cont.isSelected = false;
            this.checkedList.push(cont);
          });
          this.contactsDelete = data.contactsCostumersDelete;
          this.textTitleModal = "t-add-costumer";
          this.textTitleTabList = "t-costumers";
          this.textTitleNewContact = "t-new-costumer";
        }

        if (data.modal === "owners") {
          this.isShowOwnersForm = true;
          this.contactTypes = this.ensureLegacyContactTypeOption(
            data.contactsTypes,
            data.contact,
          );
          this.initOwnersFormValidation(data);

          data.contactsAux.forEach((c: any) => {
            const cont = c;
            cont.isSelected = false;
            this.checkedList.push(cont);
          });
          this.contactsDelete = data.contactsOwnersDelete;
          this.textTitleModal = "t-add-owner";
          this.textTitleTabList = "t-owners";
          this.textTitleNewContact = "t-new-owner";
        }

        if (data.contact) {
          this.isUpdateContact = true;
          this.textTitleModal = "t-edit-contact";
          this.textTitleNewContact = "t-edit-contact";
        }

        if (this.isShowCostumersForm || this.isShowOwnersForm) {
          this.openModal({
            tab: data.contact ? 2 : 1,
            resetContactProperties: false,
          });
          this.loadData();
          if (this.init) {
            this.searchData();
          }

          this.init = false;
        }
      }
    );

    this.subscription.add(subscriptionModalContact);

    const subscriptionTab = this.currentNavTabSubject
      .asObservable()
      .subscribe((nabTab) => {
        if (this.nabTabActive == 1) {
          this.costumersDetailsForm?.reset();
          this.submittedCostumersForm = false;
          this.ownersDetailsForm?.reset();
          this.submittedOwnersForm = false;
        }
      });

    this.subscription.add(subscriptionTab);

    const subscriptionExisteContactsToProperty = this.eventService.subscribe(
      "exist-contact-to-property",
      (data: any) => {
        this.checkedList = data.contacts;
      }
    );

    this.subscription.add(subscriptionExisteContactsToProperty);
  }

  /**
   * Form data get
   */
  get costumersForm() {
    return this.costumersDetailsForm.controls;
  }
  get ownersForm() {
    return this.ownersDetailsForm.controls;
  }

  activeIdChangeNabTab() {
    this.currentNavTabSubject.next(this.nabTabActive);
  }

  /**
   * Form Validation
   */
  initCostumersFormValidation(detailsForm: any) {
    this.costumersDetailsForm = this.formBuilder.group({
      firstName: [detailsForm?.contact?.firstName, [Validators.required]],
      lastName: [detailsForm?.contact?.lastName, [Validators.required]],
      email: [detailsForm?.contact?.email, [Validators.email]],
      phoneNumber: [detailsForm?.contact?.phoneNumber],
      contactType: [detailsForm?.contact?.contactType, [Validators.required]],
      obs: [detailsForm?.contact?.obs],
      dataConsent: [detailsForm?.contact?.dataConsent ? true : false],
      status: [detailsForm?.contact?.status ? true : false],
      hasFile: [detailsForm?.contact?.hasFile ? true : false],
      properties: [detailsForm?.contact?.properties],
      file: [detailsForm?.contact?.file ? detailsForm?.contact?.file : null],
      fiscalIdentification: [detailsForm?.contact?.fiscalIdentification || ""],
      maritalStatus: [detailsForm?.contact?.maritalStatus || ""],
      propertyRegime: [detailsForm?.contact?.propertyRegime || ""],
      birthDate: [detailsForm?.contact?.birthDate || null],
      docType: [detailsForm?.contact?.docType || ""],
      docNumber: [detailsForm?.contact?.docNumber || ""],
      docExpiration: [detailsForm?.contact?.docExpiration || null],
      naturalness: [detailsForm?.contact?.naturalness || ""],
      nationality: [detailsForm?.contact?.nationality || ""],
      city: [detailsForm?.contact?.city || ""],
      zipCode: [detailsForm?.contact?.zipCode || ""],
      fiscalCountry: [detailsForm?.contact?.fiscalCountry || ""],
      fiscalAddress: [detailsForm?.contact?.fiscalAddress || ""],
      fiscalPostalCode: [detailsForm?.contact?.fiscalPostalCode || ""],
      fiscalCity: [detailsForm?.contact?.fiscalCity || ""],
      occupation: [detailsForm?.contact?.occupation || ""],
      employer: [detailsForm?.contact?.employer || ""],
      actionType: [detailsForm?.contact?.actionType || ""],
      actionTypeOther: [detailsForm?.contact?.actionTypeOther || ""],
      politicalPositions: [detailsForm?.contact?.politicalPositions ?? false],
      politicalDesc: [detailsForm?.contact?.politicalDesc || ""],
    });
  }

  initOwnersFormValidation(detailsForm: any) {
    this.ownersDetailsForm = this.formBuilder.group({
      firstName: [detailsForm?.contact?.firstName, [Validators.required]],
      lastName: [detailsForm?.contact?.lastName, [Validators.required]],
      email: [detailsForm?.contact?.email, [Validators.email]],
      contactType: [detailsForm?.contact?.contactType, [Validators.required]],
      obs: [detailsForm?.contact?.obs],
      phoneNumber1: [detailsForm?.contact?.phoneNumber1],
      phoneNumber2: [detailsForm?.contact?.phoneNumber2],
      address: [detailsForm?.contact?.address],
      zipCode: [detailsForm?.contact?.zipCode],
      status: [detailsForm?.contact?.isActive ?? false],
      properties: [detailsForm?.contact?.properties],
      fiscalIdentification: [detailsForm?.contact?.fiscalIdentification || ""],
      maritalStatus: [detailsForm?.contact?.maritalStatus || ""],
      propertyRegime: [detailsForm?.contact?.propertyRegime || ""],
      birthDate: [detailsForm?.contact?.birthDate || null],
      docType: [detailsForm?.contact?.docType || ""],
      docNumber: [detailsForm?.contact?.docNumber || ""],
      docExpiration: [detailsForm?.contact?.docExpiration || null],
      naturalness: [detailsForm?.contact?.naturalness || ""],
      nationality: [detailsForm?.contact?.nationality || ""],
      city: [detailsForm?.contact?.city || ""],
      fiscalCountry: [detailsForm?.contact?.fiscalCountry || ""],
      fiscalAddress: [detailsForm?.contact?.fiscalAddress || ""],
      fiscalPostalCode: [detailsForm?.contact?.fiscalPostalCode || ""],
      fiscalCity: [detailsForm?.contact?.fiscalCity || ""],
      occupation: [detailsForm?.contact?.occupation || ""],
      employer: [detailsForm?.contact?.employer || ""],
      actionType: [detailsForm?.contact?.actionType || ""],
      actionTypeOther: [detailsForm?.contact?.actionTypeOther || ""],
      politicalPositions: [detailsForm?.contact?.politicalPositions ?? false],
      politicalDesc: [detailsForm?.contact?.politicalDesc || ""],
    });
  }

  openModal(
    options: { tab: number; resetContactProperties: boolean } = {
      tab: 1,
      resetContactProperties: true,
    }
  ) {
    this.nabTabActive = options.tab || 1;
    this.modalContact = this.modalService.open(this.content1, {
      backdropClass: "modal-contacts-zindex",
      size: "fullscreen",
      centered: true,
      windowClass: "modal-contacts",
      backdrop: "static",
      keyboard: false,
    });
  }

  saveCostumers() {
    if (this.checkedList.length > 0 && this.nabTabActive === 1) {
      this.checkedList.forEach((cp: any) => (cp.isAddToProperty = true));

      this.eventService.broadcast("add-exist-contact-dev", {
        kind: "costumers",
        contacts: this.checkedList,
      });

      this.modalContact.dismiss();
      this.modalContact.close();
      return;
    }

    if (this.costumersDetailsForm.valid && this.nabTabActive === 2) {
      const form = this.costumersDetailsForm.getRawValue();
      const formData = new FormData();

      // Campos básicos
      formData.append("firstName", form.firstName || "");
      formData.append("lastName", form.lastName || "");
      if (form.email) formData.append("email", form.email);
      if (form.phoneNumber) formData.append("phoneNumber", form.phoneNumber);
      formData.append("contactType", form.contactType || "");
      if (form.obs) formData.append("obs", form.obs);
      formData.append("status", form.status ? "true" : "false");
      formData.append("hasFile", form.hasFile ? "true" : "false");
      formData.append("dataConsent", form.dataConsent ? "true" : "false");

      const properties = form.properties;

      if (properties) {
        properties.forEach((p: any) => formData.append("properties[]", p));
      }
      if (form.file) formData.append("file", form.file);

      // Campos avançados (novos)
      const advancedFields = [
        "fiscalIdentification",
        "maritalStatus",
        "propertyRegime",
        "birthDate",
        "docType",
        "docNumber",
        "docExpiration",
        "naturalness",
        "nationality",
        "city",
        "zipCode",
        "fiscalCountry",
        "fiscalAddress",
        "fiscalPostalCode",
        "fiscalCity",
        "occupation",
        "employer",
        "actionType",
        "actionTypeOther",
        "politicalPositions",
        "politicalDesc",
      ];

      advancedFields.forEach((key) => {
        const value = form[key];

        if (value !== null && value !== undefined && value !== "") {
          formData.append(key, value.toString());
        }
      });

      this.contactsService
        .createCostumers(formData, { returnContact: true })
        .subscribe({
          next: (data) => {
            this.checkedList.unshift(data);

            this.checkedList.forEach((cp: any) => {
              cp.isAddToProperty = true;

              cp.isNew = form.email === cp.email;
            });

            this.eventService.broadcast("add-exist-contact-dev", {
              contacts: this.checkedList,
            });

            this.modalContact.dismiss();
            this.modalContact.close();

            this.showAlertSuccess(this.translate.instant("t-create-success"));
            this.submittedCostumersForm = false;
          },
          error: () => this.errorMsg("Error: Create costumer contact"),
        });
    }
  }

  saveOwners() {
    if (this.checkedList.length > 0 && this.nabTabActive === 1) {
      this.checkedList.forEach((cp: any) => (cp.isAddToProperty = true));

      this.eventService.broadcast("add-exist-contact-dev", {
        kind: "owners",
        contacts: this.checkedList,
      });

      this.modalContact.dismiss();
      this.modalContact.close();
      return;
    }

    if (this.ownersDetailsForm.valid && this.nabTabActive === 2) {
      const form = this.ownersDetailsForm.getRawValue();
      const formData = new FormData();

      // Básico
      formData.append("firstName", form.firstName || "");
      formData.append("lastName", form.lastName || "");
      if (form.email) formData.append("email", form.email);
      if (form.phoneNumber1) formData.append("phoneNumber1", form.phoneNumber1);
      if (form.phoneNumber2) formData.append("phoneNumber2", form.phoneNumber2);
      if (form.address) formData.append("address", form.address);
      if (form.zipCode) formData.append("zipCode", form.zipCode);
      formData.append("status", form.status ? "true" : "false");
      formData.append("contactType", form.contactType || "");
      if (form.obs) formData.append("obs", form.obs);

      const properties = form.properties;

      if (properties) {
        properties.forEach((p: any) => formData.append("properties[]", p));
      }

      // Avançado
      const advancedFields = [
        "fiscalIdentification",
        "maritalStatus",
        "propertyRegime",
        "birthDate",
        "docType",
        "docNumber",
        "docExpiration",
        "naturalness",
        "nationality",
        "city",
        "fiscalCountry",
        "fiscalAddress",
        "fiscalPostalCode",
        "fiscalCity",
        "occupation",
        "employer",
        "actionType",
        "actionTypeOther",
        "politicalPositions",
        "politicalDesc",
      ];

      advancedFields.forEach((key) => {
        const value = form[key];
        if (value !== null && value !== undefined && value !== "") {
          formData.append(key, value.toString());
        }
      });

      this.contactsService
        .createOwners(formData, { returnContact: true })
        .subscribe({
          next: (data) => {
            this.checkedList.unshift(data);
            this.checkedList.forEach((cp: any) => {
              cp.isAddToProperty = true;
              cp.isNew = form.email === cp.email;
            });
            this.eventService.broadcast("add-exist-contact-dev", {
              contacts: this.checkedList,
            });
            this.modalContact.dismiss();
            this.modalContact.close();
            this.showAlertSuccess(this.translate.instant("t-create-success"));
            this.submittedOwnersForm = false;
          },
          error: () => this.errorMsg("Error: Create owner contact"),
        });
    }
  }

  save() {
    if (this.isShowOwnersForm) {
      this.saveOwners();
      if (this.nabTabActive == 2) this.submittedOwnersForm = true;
    }

    if (this.isShowCostumersForm) {
      this.saveCostumers();
      if (this.nabTabActive == 2) this.submittedCostumersForm = true;
    }
  }

  switchStatus(event: any) {
    this.statusOwners = event.target.checked;
  }

  /**
   * show sweet alert success
   * @param position modal content
   */
  showAlertSuccess(msg: string) {
    Swal.fire({
      icon: "success",
      title: msg,
      showConfirmButton: false,
      timer: 1500,
    });
  }

  /**
   * paginate
   */
  paginate() {
    if (!this.propertyId) {
      this.pageSize = 10;
      this.endIndex = 10;
    }
    this.startIndex = (this.page - 1) * this.pageSize + 1;
    this.endIndex = (this.page - 1) * this.pageSize + this.pageSize;
    if (this.endIndex > this.total) {
      this.endIndex = this.total;
    }
  }

  /**
   * The master checkbox will check/uncheck all items
   * @param event
   */
  checkUncheckAll(event: any) {
    if (event.target.checked) {
      for (let i = 0; i < this.contacts.length; i++) {
        this.contacts[i].isSelected = event.target.checked;
        this.contacts[i].isNew = event.target.checked;
        const cont = this.checkedList.find(
          (c: any) => c.id == this.contacts[i].id
        );
        if (!cont) {
          this.checkedList.unshift(this.contacts[i]);
        }
      }
    } else {
      for (let i = 0; i < this.contacts.length; i++) {
        this.contacts[i].isSelected = event.target.checked;
        this.contacts[i].isNew = event.target.checked;
        const pos = this.checkedList.findIndex(
          (c: any) => c.id == this.contacts[i].id
        );
        if (pos !== -1) {
          this.checkedList.splice(pos, 1);
        }
      }
    }
    this.getCheckedItemList();
  }

  /**
   * check/ uncheck all items
   * @param event
   * @param contact
   */
  checkUncheck(event: any, contact: any) {
    contact.isSelected = event.target.checked;

    contact.isNew = event.target.checked;

    if (event.target.checked) {
      this.checkedList.unshift(contact);
    } else {
      this.checkedList = this.checkedList.filter(
        (c: any) => c.id !== contact.id
      );
    }
    this.getCheckedItemList();
  }

  /**
   * Get List of Checked Items
   */
  getCheckedItemList() {
    let countCheckSelected = 0;
    for (let i = 0; i < this.contacts.length; i++) {
      if (this.contacts[i].isSelected) {
        countCheckSelected++;
      }
    }
    if (countCheckSelected == this.contacts.length) this.masterSelected = true;
    else this.masterSelected = false;
  }

  searchData() {
    let contactsAux = this.checkedList.filter(
      (c) => c.isAddToProperty === true
    );
    let contactsIds = contactsAux.map((co) => co.id);
    let includeContactsIds = this.contactsDelete.map((c) => c.id);
    if (this.isShowCostumersForm) {
      const subscriptiongetSearchCostumers = this.queryField.valueChanges
        .pipe(
          map((value) => value.trim()),
          debounceTime(200),
          distinctUntilChanged(),
          tap((value) => {
            this.filter = value;
            contactsAux = this.checkedList.filter(
              (c) => c.isAddToProperty === true
            );
            contactsIds = contactsAux.map((co) => co.id);
            includeContactsIds = this.contactsDelete.map((c) => c.id);
          }),
          switchMap((value) =>
            this.contactsService.getAllCostumersWithOutProperty(
              this.propertyId,
              this.page,
              this.filter,
              contactsIds,
              includeContactsIds
            )
          ),
          tap((data) => (this.total = data.total)),
          map((data) => data.costumers),
          tap(() => this.paginate()),
          tap(() => (this.noresult = false))
        )
        .subscribe((costumers) => {
          this.contacts = costumers;
          if (this.total === 0) {
            this.noresult = true;
          }
          this.contacts.forEach((c) => {
            const ca = this.checkedList.find((ca) => ca.id === c.id);
            if (ca) {
              c.isSelected = ca.isSelected;
              c.isNew = ca.isNew;
            }
          });
          this.getCheckedItemList();
        });
      this.subscription.add(subscriptiongetSearchCostumers);
    } else if (this.isShowOwnersForm) {
      const subscriptiongetSearchOwners = this.queryField.valueChanges
        .pipe(
          map((value) => value.trim()),
          debounceTime(200),
          distinctUntilChanged(),
          tap((value) => {
            this.filter = value;
            contactsAux = this.checkedList.filter(
              (c) => c.isAddToProperty === true
            );
            contactsIds = contactsAux.map((co) => co.id);
            includeContactsIds = this.contactsDelete.map((c) => c.id);
          }),
          switchMap((value) =>
            this.contactsService.getAllOwnersWithOutProperty(
              this.propertyId,
              this.page,
              this.filter,
              contactsIds,
              includeContactsIds
            )
          ),
          tap((data) => (this.total = data.total)),
          map((data) => data.owners),
          tap(() => this.paginate()),
          tap(() => (this.noresult = false))
        )
        .subscribe((owners) => {
          this.contacts = owners;
          if (this.total === 0) {
            this.noresult = true;
          }
          this.contacts.forEach((c) => {
            const ca = this.checkedList.find((ca) => ca.id === c.id);
            if (ca) {
              c.isSelected = ca.isSelected;
              c.isNew = ca.isNew;
            }
          });
          this.getCheckedItemList();
        });
      this.subscription.add(subscriptiongetSearchOwners);
    }
  }

  loadData() {
    if (this.isShowCostumersForm) {
      const contactsAux = this.checkedList.filter(
        (c) => c.isAddToProperty === true
      );
      const contactsIds = contactsAux.map((co) => co.id);
      const includeContactsIds = this.contactsDelete.map((c) => c.id);
      const subscriptiongetAllCostumers = this.contactsService
        .getAllCostumersWithOutProperty(
          this.propertyId,
          this.page,
          this.filter,
          contactsIds,
          includeContactsIds
        )
        .pipe(
          tap(() => (this.hideElement = true)),
          tap((data) => (this.total = data.total)),
          map((data) => data.costumers),
          tap(() => this.paginate()),
          finalize(() => {
            this.hideElement = false;
          })
        )
        .subscribe((costumers) => {
          if (this.propertyId) {
            this.allContacts = costumers;
            const start = (this.page - 1) * this.pageSize;
            const end = start + this.pageSize;
            this.contacts = costumers.slice(start, end);
            this.contacts.forEach((c) => {
              const ca = this.checkedList.find((ca) => ca.id === c.id);
              if (ca) {
                c.isSelected = ca.isSelected;
                c.isNew = ca.isNew;
              }
            });
            this.getCheckedItemList();
          } else {
            this.contacts = costumers;
            this.contacts.forEach((c) => {
              const ca = this.checkedList.find((ca) => ca.id === c.id);
              if (ca) {
                c.isSelected = ca.isSelected;
                c.isNew = ca.isNew;
              }
            });
            this.getCheckedItemList();
          }
        });
      this.subscription.add(subscriptiongetAllCostumers);
    } else if (this.isShowOwnersForm) {
      const contactsAux = this.checkedList.filter(
        (c) => c.isAddToProperty === true
      );
      const contactsIds = contactsAux.map((co) => co.id);
      const includeContactsIds = this.contactsDelete.map((c) => c.id);
      const subscriptiongetAllOwners = this.contactsService
        .getAllOwnersWithOutProperty(
          this.propertyId,
          this.page,
          this.filter,
          contactsIds,
          includeContactsIds
        )
        .pipe(
          tap(() => (this.hideElement = true)),
          tap((data) => (this.total = data.total)),
          map((data) => data.owners),
          tap(() => this.paginate()),
          finalize(() => {
            this.hideElement = false;
          })
        )
        .subscribe((owners) => {
          this.contacts = owners;
          this.contacts.forEach((c) => {
            const ca = this.checkedList.find((ca) => ca.id === c.id);
            if (ca) {
              c.isSelected = ca.isSelected;
              c.isNew = ca.isNew;
            }
          });
          this.getCheckedItemList();
        });
      this.subscription.add(subscriptiongetAllOwners);
    }
  }

  refreshContacts() {
    if (this.propertyId) {
      if (this.allContacts && this.allContacts.length > 0) {
        const start = (this.page - 1) * this.pageSize;
        const end = start + this.pageSize;

        this.contacts = this.allContacts.slice(start, end);

        this.contacts.forEach((c) => {
          const ca = this.checkedList.find((ca) => ca.id === c.id);
          if (ca) {
            c.isSelected = ca.isSelected;
            c.isNew = ca.isNew;
          }
        });

        this.getCheckedItemList();
        this.paginate();
      }
    } else {
      this.loadData();
    }
  }

  /**
   * Title sweet alert
   * @param Error Msg modal content
   */
  errorMsg(errorMsg: string) {
    Swal.fire({
      title: "Oops...! Something went Wrong !",
      text: errorMsg,
      icon: "warning",
      confirmButtonColor: "rgb(54, 69, 116)",
      confirmButtonText: "Close",
    });
  }

  onFileChange(event: any) {
    if (event.target.files && event.target.files.length) {
      if (this.isShowCostumersForm) {
        const [file] = event.target.files;
        this.costumersDetailsForm.patchValue({
          file: file,
        });
        this.costumersDetailsForm.patchValue({ hasFile: true });
        this.costumersDetailsForm.patchValue({ dataConsent: false });
      }
    }

    event.target.value = "";
  }

  addFileCostumer() {
    const inputFile = document.getElementById("input-filec");
    inputFile?.click();
  }

  deleteFile() {
    this.costumersDetailsForm.patchValue({
      file: null,
    });
    this.costumersDetailsForm.patchValue({ hasFile: false });
    this.costumersDetailsForm.patchValue({ dataConsent: false });
  }

  formatSizeUnits(bytes: any) {
    if (bytes >= 1073741824) {
      bytes = (bytes / 1073741824).toFixed(2) + " GB";
    } else if (bytes >= 1048576) {
      bytes = (bytes / 1048576).toFixed(2) + " MB";
    } else if (bytes >= 1024) {
      bytes = (bytes / 1024).toFixed(2) + " KB";
    } else if (bytes > 1) {
      bytes = bytes + " bytes";
    } else if (bytes == 1) {
      bytes = bytes + " byte";
    } else {
      bytes = "0 bytes";
    }
    return bytes;
  }

  getDash(quality: number) {
    const circumference = 2 * Math.PI * 15.91549430918954;
    const offset = circumference - (quality / 100) * circumference;
    return `${circumference - offset} ${circumference}`;
  }

  closeModal() {
    this.phoneExists = false;
    this.emailExists = false;
    this.phoneInvalid = false;
    this.emailInvalid = false;
  }

  contactInputChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const valueInput = inputElement.value;
    const field = inputElement.name;

    const data = {
      field: field,
      value: valueInput,
    };

    const emailValid = new FormControl(valueInput, [
      Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/),
    ]);

    const phoneValid = new FormControl(valueInput, [
      Validators.pattern(
        /^(\+351|351)?\s*(2\d{8}|9(0\d|1\d|2\d|3\d|4\d|5\d|6\d|7\d|8\d|9\d)\d{6})$/
      ),
    ]);

    if (valueInput.length === 0) {
      if (field === "email") {
        this.emailInvalid = false;
        this.emailExists = false;
      } else if (field === "phoneNumber") {
        this.phoneInvalid = false;
        this.phoneExists = false;
      }
      return;
    }

    if (valueInput.length > 1 && emailValid.errors && field === "email") {
      this.emailInvalid = true;
    } else if (
      valueInput.length > 1 &&
      phoneValid.errors &&
      field === "phoneNumber"
    ) {
      this.phoneInvalid = true;
      this.phoneExists = false;
    }

    if (emailValid.valid || phoneValid.valid) {
      if (phoneValid.valid) {
        this.phoneInvalid = false;
      }
      if (emailValid.valid) {
        this.emailInvalid = false;
      }

      if (field === "phoneNumber") {
        data.value = valueInput.replace(/\D/g, "").replace(/^351/, "");
      }

      this.contactsService.contactExists(data).subscribe((exist) => {
        if (field === "email") {
          this.emailExists = exist;
        } else if (field === "phoneNumber") {
          this.phoneExists = exist;
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
